import React from 'react';
import { QStack } from '../../../QLayouts';

export const FormContent: React.FC = ({ children }) => (
  <QStack spacing="16px">{children}</QStack>
);
FormContent.displayName = 'FilterFormContent';
